(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('archingController', archingController);

    archingController.$inject = ['$stateParams', 'currencies', 'linkService', 'dateService', 'balanceUserService', 'printService'];

    function archingController($stateParams, currencies, linkService, dateService, balanceUserService, printService){
        var vm = this;
        vm.currencies = currencies;
        vm.filterArching = {
            currency: null,
            toDate : 1,
            type: {"1": false, "2": false, "3": false, "4": false},
            types: [
                {id: 1, name: "air.arching.filter.passage"},
                {id: 2, name: "air.arching.filter.cargo"},
                {id: 3, name: "air.arching.filter.luggage"},
                {id: 4, name: "air.arching.filter.ssr"}
            ],
            typeValues: ["PASSAGE", "CARGO", "LUGGAGE", "SSR"],
            detail: true
        }

        vm.isReport = false;
        vm.isDownload = false;
        vm.reportBalanceHtml = '';
        vm.toDate = null;
        vm.type = '';

        vm.cancelSalesBook = function (formGenerateSalesBook) {
            vm.filterSalesBook.taxpayer = null;
            vm.filterSalesBook.economicActivity = null;
            vm.filterSalesBook.management = null;
            formGenerateSalesBook.$setPristine();
        }

        vm.generateArching = function (isValid, formGenerateArching) {
            if(isValid){
                var newDate = new Date();
                vm.toDate = null;
                vm.type = '';

                if (vm.filterArching.toDate === 1) {
                    vm.toDate = dateService.dateTimeString(newDate, 1);
                } else if (vm.filterArching.toDate === 2) {
                    vm.toDate = dateService.dateTimeString(new Date(newDate.setDate(newDate.getDate() - 1)), 1);
                } else if (vm.filterArching.toDate === 3) {
                    vm.toDate = dateService.dateTimeString(new Date(newDate.setDate(newDate.getDate() - 2)), 1);
                }

                Object.keys(vm.filterArching.type).forEach(function(key) {
                    if (vm.filterArching.type[key] === true) {
                        vm.type = vm.type + 'type=' + vm.filterArching.typeValues[parseInt(key) - 1] + '&';
                    }
                });

                balanceUserService.getReportBalanceUser(vm.type, vm.toDate, vm.filterArching.detail).then(function (response) {
                    vm.reportBalanceHtml = response.data;
                    vm.isReport = true;
                });
            }
        }

        vm.generateArchingPdf = function () {
            balanceUserService.getReportBalanceUserPdf(vm.type, vm.toDate, vm.filterArching.detail).then(function (response) {
                if(response !== undefined){
                    var filePdf = new Blob([response.data], { type: 'application/pdf'});
                    var nameFile = 'arching-' + (new Date()).getTime() + '.pdf';
                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(filePdf, nameFile);
                    }else{
                        var fileURL = URL.createObjectURL(filePdf);
                        var a = document.createElement('a');
                        a.href = fileURL;
                        a.target = '_blank';
                        a.download = nameFile;
                        document.body.appendChild(a);
                        a.click();
                    }
                }

            });
        }

        vm.generateArchingPdfHtml = function () {
            printService.printPdfHtml("reportBalanceHtml");
        }

        vm.cancelGenerateArching = function(formGenerateArching) {
            vm.filterArching.currency = null;
            vm.filterArching.toDate = 1;
            vm.filterArching.type = {"1": false, "2": false, "3": false};
            vm.filterArching.detail = true;
            vm.reportBalanceHtml = '';
            vm.toDate = null;
            vm.type = '';
            vm.isReport = false;
            formGenerateArching.$setPristine();
        };
    }
})();
